module.exports = __webpack_public_path__ + "static/img/2.25da168.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/2.png
// module id = Fcy0
// module chunks = 0